import React, { useState, useEffect } from "react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Alert, AlertDescription, AlertTitle } from "../../components/ui/alert";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../components/ui/dialog";
import { AlertTriangle, Eye, Save, Download, X, Check, FileText, FolderOpen } from "lucide-react";

import { useParams } from "react-router";

import NewEditCategory from "../AddEdit/NewEditCategory";
import Summary from "./Summary";
import ListJson from "./ListJson";
import SearchInfo from "./SearchInfo";
import EditJson from "categories/EditJson/EditJson";
import AddNewJson from "categories/EditJson/AddNew";

import { useSelector, shallowEqual, useDispatch } from "react-redux";

import {
  SG_EDIT_SURVEY_STRUCTURE,
  SG_FETCH_SURVEY_STRUCTURE,
  PULL_ORGANIZATION,
  SG_CSV_FILE_SURVEY_STRUCTURE,
  CSV_FILE_SURVEY_STRUCTURE,
} from "constants/actions";

import ViewJson from "./viewJson";

const Categories = ({ setOrgName }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [organizationId, setOrganizationId] = useState(false);

  const [surveyStruc, setSurveyStruc] = useState({});
  const [surveyStrucRow, setSurveyStrucRow] = useState([]);
  const [rowId, setRowId] = useState(0);
  const [openNewCategory, setOpenNewCategory] = useState(false);
  const [errorList, setErrorList] = useState([]);

  const [surveyStructureId, setSurveyStructureId] = useState(false);

  const [openSummary, setOpenSummary] = useState(false);
  const [openNameEdit, setOpenNameEdit] = useState(false);
  const [openNameChanged, setOpenNameChanged] = useState(false);

  const [openEditJson, setOpenEditJson] = useState(false);
  const [openViewSummary, setOpenViewSummary] = useState(false);
  const [updateJsonFile, setUpdateJsonFile] = useState(0);
  const [savedSuccessFully, setSavedSuccessFully] = useState(false);
  const [loading, setLoading] = useState(false);
  const [csvDownloadFile, setCsvDownloadFile] = useState(false);

  const [openNewJson, setOpenNewJson] = useState(false);

  const { get_survey_structure, get_organizations } = useSelector(
    (state) => ({
      get_organizations: state.organizations,
      get_survey_structure: state.surveystructure,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (Number(id) > 0) {
      dispatch({
        type: SG_FETCH_SURVEY_STRUCTURE,
        payload: { id },
      });
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (organizationId) {
      dispatch({
        type: PULL_ORGANIZATION,
        payload: { id: organizationId },
      });
    }
  }, [dispatch, organizationId]);

  function SaveSurveyStructure() {
    if (surveyStructureId) {
      setLoading(true);
      setUpdateJsonFile(0);
      dispatch({
        type: SG_EDIT_SURVEY_STRUCTURE,
        payload: {
          id: surveyStructureId,
          categories: surveyStrucRow,
        },
      });
    }
  }

  function RegenerateCsvStructure() {
    if (surveyStructureId) {
      dispatch({
        type: SG_EDIT_SURVEY_STRUCTURE,
        payload: {
          id: surveyStructureId,
          regenerate_csv: "yes",
        },
      });
    }
  }

  function GenerateCsvFile() {
    if (surveyStructureId) {
      dispatch({
        type: SG_CSV_FILE_SURVEY_STRUCTURE,
        payload: {
          survey_structure_id: surveyStructureId,
        },
      });
    }
  }

  useEffect(() => {
    if (get_survey_structure) {
      setCsvDownloadFile(get_survey_structure?.csv_file?.download_csv_link);
    }
  }, [get_survey_structure, dispatch]);

  function Downloadcsv() {
    if (csvDownloadFile) {
      window.open(csvDownloadFile, "_blank");
      dispatch({ type: CSV_FILE_SURVEY_STRUCTURE, payload: null }); // Reset the download state
    }
  }

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setLoading(get_survey_structure?.pending);
      if (updateJsonFile > 0 && get_survey_structure?.pending === false) {
        setSavedSuccessFully(true);
      }
    }, 1000);
    return () => clearTimeout(timer1);
  }, [get_survey_structure, updateJsonFile]);

  useEffect(() => {
    if (id) {
      setSurveyStrucRow(get_survey_structure?.[id]?.categories);
      setSurveyStructureId(id);
      setOpenNameChanged(get_survey_structure?.[id]?.name);
      setOrganizationId(get_survey_structure?.[id]?.organization);
    }
  }, [get_survey_structure, id]);

  useEffect(() => {
    setOrgName(get_organizations?.[organizationId]?.name);
  }, [get_organizations, organizationId, setOrgName]);

  console.log("surveyStrucRow", surveyStrucRow);
  useEffect(() => {
    if (surveyStrucRow) {
      const ErrorMessage = [];
      let PrimaryFound = false;
      let SecondaryFound = false;
      surveyStrucRow.map((row) => {
        if (row.priority === "primary" && !PrimaryFound) {
          PrimaryFound = true;
        }
        if (row.priority === "secondary" && !SecondaryFound) {
          SecondaryFound = true;
        }
        return null;
      });

      if (!PrimaryFound) {
        ErrorMessage.push(
          "No row with Priority Primary Found, atleast one row with Priority Primary is essenstial"
        );
      }
      if (!SecondaryFound) {
        ErrorMessage.push(
          "No row with Priority Secondary Found, atleast one row with Priority Secondary is essenstial"
        );
      }
      setErrorList(ErrorMessage);
    }
  }, [surveyStrucRow]);

  function EditName() {
    // console.log(openNameChanged)
    if (surveyStructureId && openNameChanged?.length > 3) {
      dispatch({
        type: SG_EDIT_SURVEY_STRUCTURE,
        payload: {
          id: surveyStructureId,
          name: openNameChanged,
        },
      });
      setOpenNameEdit(false);
    }
  }

  function AddNewCategory() {
    setOpenNewCategory(true);
    setRowId(0);
    setSurveyStruc({});
  }


  return (
    <div className="mb-8 space-y-6">
      <Alert className="border-orange-500/40 bg-orange-50 dark:bg-orange-950/20">
        <AlertTriangle className="h-4 w-4" />
        <AlertTitle className="text-orange-900 dark:text-orange-200">Do not modify before you read this</AlertTitle>
        <AlertDescription>
          This data is crucial for the entire survey. Please do not change or add anything on this page without consulting the support team.
          Any errors will appear below. Even if there are no errors, things may break if you change this file without proper knowledge.
          To modify, please contact support.
        </AlertDescription>
      </Alert>

      {errorList && errorList.length > 0 && (
        <Alert variant="destructive">
          <AlertTriangle className="h-4 w-4" />
          <AlertTitle>Errors</AlertTitle>
          <AlertDescription>
            <ul className="list-disc pl-5 space-y-1">
              {errorList.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          </AlertDescription>
        </Alert>
      )}

      {updateJsonFile > 0 && (
        <Alert className="border-amber-500/40 bg-amber-50 dark:bg-amber-950/20">
          <FolderOpen className="h-4 w-4" />
          <AlertTitle>NOT SAVED</AlertTitle>
          <AlertDescription>Please click the Save button below to persist your changes.</AlertDescription>
        </Alert>
      )}
      {updateJsonFile === 0 && savedSuccessFully && (
        <Alert className="border-emerald-500/40 bg-emerald-50 dark:bg-emerald-950/20">
          <Save className="h-4 w-4" />
          <AlertTitle>Saved Successfully</AlertTitle>
          <AlertDescription>The contents were saved successfully.</AlertDescription>
        </Alert>
      )}

      {openNameEdit ? (
        <div className="flex items-center justify-center gap-2">
          <Input
            placeholder="Category Name"
            name="name"
            defaultValue={openNameChanged}
            onChange={(v) => setOpenNameChanged(v.target.value)}
            className="max-w-md"
          />
          <Button variant="secondary" size="icon" onClick={EditName} aria-label="Save name">
            <Check className="h-4 w-4" />
          </Button>
          <Button variant="destructive" size="icon" onClick={() => setOpenNameEdit(false)} aria-label="Cancel name edit">
            <X className="h-4 w-4" />
          </Button>
        </div>
      ) : (
        <div className="text-center">
          <button
            type="button"
            onClick={() => setOpenNameEdit(true)}
            className="mx-auto inline-flex items-center gap-2 rounded-md px-3 py-2 text-xl font-semibold hover:bg-muted"
          >
            <FileText className="h-5 w-5" />
            <span>{openNameChanged}</span>
          </button>
        </div>
      )}
      <NewEditCategory
        surveyStruc={surveyStruc}
        setSurveyStruc={setSurveyStruc}
        rowId={rowId}
        surveyStrucRow={surveyStrucRow}
        setSurveyStrucRow={setSurveyStrucRow}
        openNewCategory={openNewCategory}
        organizationId={organizationId}
        surveyStructureId={surveyStructureId}
        setOpenNewCategory={setOpenNewCategory}
        setUpdateJsonFile={setUpdateJsonFile}
        setLoading={setLoading}
      />

      <div className="mt-6 flex w-full flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Button onClick={AddNewCategory} variant="secondary">
            + New Category
          </Button>
          <Button onClick={() => setOpenNewJson(true)} variant="destructive">
            Replace or Add New JSON
          </Button>
        </div>
      </div>

      <SearchInfo surveyStrucRow={surveyStrucRow} />

      <ListJson
        surveyStrucRow={surveyStrucRow}
        setSurveyStrucRow={setSurveyStrucRow}
        surveyStructureId={surveyStructureId}
        setRowId={setRowId}
        setSurveyStruc={setSurveyStruc}
        setOpenNewCategory={setOpenNewCategory}
        setUpdateJsonFile={setUpdateJsonFile}
        loading={loading}
        setLoading={setLoading}
      />

      <ViewJson details={get_survey_structure} />

      <div className="mt-6 flex flex-wrap items-center gap-2">
        <Button onClick={() => setOpenViewSummary(true)} variant="outline">
          <Eye className="h-4 w-4" />
          View as JSON Summary
        </Button>

        <Button onClick={() => setOpenSummary(true)} variant="outline">
          <Eye className="h-4 w-4" />
          View Summary
        </Button>

        <Button
          disabled={updateJsonFile === 0 ? true : false}
          onClick={() => SaveSurveyStructure()}
          variant={updateJsonFile === 0 ? "secondary" : "default"}
        >
          <Save className="h-4 w-4" />
          Save
        </Button>

      {/* <Button
        style={{ margin: "20px 20px" }}
        icon
        labelPosition="right"
        floated="right"
        onClick={() => setOpenEditJson(true)}
        size="small"
        color="violet"
      >
        Edit JSON Values
        <Icon name="save" />
      </Button> */}

        <Button onClick={() => setOpenEditJson(true)} variant="secondary">
          <Save className="h-4 w-4" />
          Edit JSON
        </Button>

        {csvDownloadFile ? (
          <Button onClick={Downloadcsv} variant="outline">
            <Download className="h-4 w-4" />
            Download CSV
          </Button>
        ) : (
          <Button onClick={GenerateCsvFile} variant="outline">
            <Download className="h-4 w-4" />
            Download CSV
          </Button>
        )}

        <Button onClick={RegenerateCsvStructure} variant="default">
          <Save className="h-4 w-4" />
          Update CSV (in app)
        </Button>
      </div>

      <EditJson
        surveyStructureId={surveyStructureId}
        openEditJson={openEditJson}
        setOpenEditJson={setOpenEditJson}
        openViewSummary={openViewSummary}
        setOpenViewSummary={setOpenViewSummary}
      />

      <AddNewJson
        surveyStructureId={surveyStructureId}
        openNewJson={openNewJson}
        setOpenNewJson={setOpenNewJson}
        openViewSummary={openViewSummary}
        setOpenViewSummary={setOpenViewSummary}
      />
      <Dialog open={openSummary} onOpenChange={setOpenSummary}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Category Summary</DialogTitle>
            <DialogDescription>
              Detailed summary of the JSON file. This is how the information gets processed.
            </DialogDescription>
          </DialogHeader>
          <div className="max-h-[60vh] overflow-auto">
            <Summary
              surveyStrucRow={surveyStrucRow}
              surveyStructure={get_survey_structure}
            />
          </div>
          <DialogFooter>
            <Button onClick={() => setOpenSummary(false)} variant="secondary">
              <X className="h-4 w-4" />
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Categories;

